// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"94f18ec5","464":"fd71d691","569":"946d7742","777":"972b5505","787":"871b41c3","957":"f517ec86"}[chunkId] + ".chunk.js";
};